<template>
    <div class="com-item tablist-module" :key="index">
        <div class="component person-nav">
            <div class="van-sticky" :style="{
                backgroundColor: modata.WContent.bgColor || '#004ea2',
                backgroundImage: modata.WContent.bgImg ? 'url(' + modata.WContent.bgImg + ')' : 'none',
                backgroundSize: 'cover',
                backgroundPosition: 'center',
                color: modata.WContent.textColor || '#fff'
            }">
                <div class="tablist-module__inner">
                    <div
                        v-for="(item, idx) in modata.WContent.items"
                        v-show="idx === navIndex"
                        :key="idx"
                        class="tablist-module__pane"
                    >
                        <div class="tablist-module__pane-left">
                            <div class="tablist-module__pane-inner">
                                <p class="tablist-module__pane-title">{{ item.tabName }}</p>
                                <p class="tablist-module__pane-desc">{{ item.describe }}</p>
                                <a
                                    v-if="item.btnLink && item.btnLink.linkUrl"
                                    class="tablist-module__pane-btn"
                                    :href="item.btnLink.linkUrl"
                                    target="_self"
                                >{{ item.btnText || '探索详情 →' }}</a>
                            </div>
                        </div>
                        <div class="tablist-module__pane-right">
                            <div class="tablist-module__pane-inner">
                                <p class="tablist-module__pane-label">{{ item.imgLabel || '产品服务' }}</p>
                                <div class="tablist-module__pane-img">
                                    <img v-if="item.imgUrl" :src="item.imgUrl" alt="" />
                                </div>
                            </div>
                        </div>
                    </div>

                    <div
                        v-if="modata.WContent.items && modata.WContent.items.length"
                        class="tablist-module__tabs"
                        :style="{
                            '--tab-color': modata.WContent.tabColor || '#737373',
                            '--tab-active-color': modata.WContent.tabActiveColor || '#004ea2'
                        }"
                    >
                        <span
                            v-for="(item, idx) in modata.WContent.items"
                            :key="idx"
                            class="tablist-module__tab"
                            :class="{ 'is-active': idx === navIndex }"
                            @click="navIndex = idx"
                        >{{ item.tabName || ('Tab ' + (idx + 1)) }}</span>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: "tablist-module",
    components: {},
    props: {
        index: {
            type: Number
        },
        type: {
            type: String,
            default: 'preview'
        },
        isactive: {
            type: Boolean,
            default: false
        },
        phoneWidth: {
            type: Number,
            default: 1280
        },
        proportion: {
            type: Number,
            default: 1
        },
        modata: {
            type: Object,
            default: function() {
                return {
                    WName: 'tablist',
                    Title: '标签列表',
                    MID: 18,
                    WID: null,
                    ModuleName: 'tablist-module',
                    WContent: {}
                }
            }
        }
    },
    data() {
        return {
            navIndex: 0
        }
    },
    mounted() {},
    beforeDestroy() {},
    methods: {
        bindPage(item) {
            if (!item || !item.btnLink || !item.btnLink.linkUrl) return
            this.pageNavigate(item.btnLink.linkUrl)
        },
        pageNavigate(path) {
            if (!path) return
            if (/^(https?:|mailto:|tel:)/.test(path)) {
                window.open(path)
            } else if (this.$router) {
                this.$router.push(path)
            } else {
                window.location.href = path
            }
        }
    },
    watch: {},
    filters: {}
}
</script>

<style scoped lang="scss">
p {
    margin: 0;
}
.tablist-module {
    .tablist-module__inner {
        width: 100%;
        max-width: 1600px;
        margin: 0 auto;
        padding: 7% 0;
    }

    .tablist-module__pane {
        display: flex;
        align-items: center;
        min-height: 300px;
        animation: fadeIn 0.4s both;
    }
      .tablist-module__pane-inner {
        width: 70%;
        margin: 0 auto;
         animation: fadeInRight 1s both
    }

    .tablist-module__pane-left {
        flex: 0 0 50%;
        background: #004ea2;
        align-self: stretch;
        display: flex;
        align-items: center;
        .tablist-module__pane-inner {

         animation: fadeInLeft 1s both
       }
    }

    .tablist-module__pane-right {
        flex: 0 0 50%;
        align-self: stretch;
        display: flex;
        align-items: start;
        justify-content: center;
        .tablist-module__pane-inner {
        animation: fadeInRight 1s both
      }
    }

  

    .tablist-module__pane-title {
        font-size: 46px;
        color: #fff;
        font-family: "pingfang heavy", "PingFang SC", sans-serif;
        line-height: 1;
        margin: 30px 0 0;
    }

    .tablist-module__pane-desc {
        font-size: 16px;
        color: #fff;
        line-height: 1.9;
        min-height: 160px;
        max-width: 575px;
        margin: 25px 0 0;
    }

    .tablist-module__pane-btn {
        display: inline-block;
        box-sizing: border-box;
        width: 160px;
        margin-top: 40px;
        padding: 12px 0;
        text-align: center;
        background: transparent;
        border: 2px solid #fff;
        border-radius: 45px;
        color: #fff;
        font-size: 15px;
        text-decoration: none;
        transition: all 0.3s;

        &:hover {
            background: #fff;
            color: #004ea2;
        }
    }

    .tablist-module__pane-label {
        font-size: 36px;
        color: #262626;
        font-family: "pingfang heavy", "PingFang SC", "Microsoft YaHei", sans-serif;
        text-align: center;
        margin: 0;
    }

    .tablist-module__pane-img {
        max-width: 358px;
        margin: 5% auto 8%;

        img {
            width: 100%;
            height: auto;
            display: block;
            object-fit: contain;
        }
    }

    .tablist-module__tabs {
        display: flex;
        justify-content: center;
        width: 50%;
        margin-left: auto;
        margin-top: 20px;
    }

    .tablist-module__tab {
        display: block;
        line-height: 40px;
        text-align: center;
        font-size: 18px;
        color: var(--tab-color);
        padding: 0 20px;
        cursor: pointer;
        position: relative;
        transition: all 0.3s;

        &.is-active {
            color: var(--tab-active-color);
            font-size: 21px;
            font-family: "pingfang heavy", "PingFang SC", "Microsoft YaHei", sans-serif;
        }
    }
}

@keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
}

@media screen and (max-width: 768px) {
    .van-sticky{
        background-color: #004ea2 !important;
        background-image: none !important;

    }
    .tablist-module {


        .tablist-module__inner{
            display: flex;
           flex-direction: column-reverse;
        }

         .tablist-module__tabs {
            width: 100%;
            margin-bottom: 30px;
            flex-wrap: wrap;
             align-items: baseline;
        }
        .tablist-module__tab {
            color: #fff;
            padding: 0 5px;
            font-size:20px ;
        }
        .tablist-module__tab.is-active{
            color: #fff;
            font-weight: 700;
            font-size: 24px;
            
        }
       




       .tablist-module__pane-img {
            max-width: 160px;
            margin: 5% auto;
        }




        .tablist-module__pane {
            flex-direction: column-reverse;
        }
        .tablist-module__pane-left,
        .tablist-module__pane-right {
            flex: 0 0 auto;
            width: 100%;
        }

         .tablist-module__pane-left{
            margin-top: -38px;
         }


        .tablist-module__pane-inner{
            width: 90%;
        }
        .tablist-module__pane-title {
            font-size: 26px;
            line-height: 1;
            margin-top: 0;
        }
        .tablist-module__pane-desc {
            font-size: 18px;
            line-height: 1.5;
            min-height: 0;
            margin-top: 20px;
        }
        .tablist-module__pane-btn {
            margin-top: 10px;
            width: 120px;
            padding-top: 8px;
            padding-bottom: 8px;
        }
        .tablist-module__pane-label {
            display: none;
        }
       


        
        
    }
}
</style>
